import React, { useState, useEffect } from 'react';
import './StaggeredContainer.scss';

const StaggeredContainer = ({
  children,
  type = 'bottom',
  delay = 0,
  staggerDelay = 100,
  duration = 400,
  appear = true,
  enabled = true,
  className = '',
  ...props
}) => {
  const [isVisible, setIsVisible] = useState(appear);
  const [animatedChildren, setAnimatedChildren] = useState([]);

  useEffect(() => {
    if (enabled && !isVisible) {
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, delay);
      return () => clearTimeout(timer);
    } else if (!enabled && isVisible) {
      setIsVisible(false);
    }
  }, [enabled, delay, isVisible]);

  useEffect(() => {
    if (isVisible && children) {
      const childArray = React.Children.toArray(children);
      const animatedArray = [];

      childArray.forEach((child, index) => {
        if (React.isValidElement(child)) {
          const animationDelay = index * staggerDelay;
          const animatedChild = React.cloneElement(child, {
            key: child.key || index,
            style: {
              ...child.props.style,
              animationDelay: `${animationDelay}ms`,
              animationDuration: `${duration}ms`,
              animationFillMode: 'both',
            },
            className: `${child.props.className || ''} staggered-item staggered-${type} ${isVisible ? 'staggered-visible' : ''}`,
          });
          animatedArray.push(animatedChild);
        }
      });

      setAnimatedChildren(animatedArray);
    }
  }, [isVisible, children, staggerDelay, duration, type]);

  if (!enabled) {
    return null;
  }

  return (
    <div className={`staggered-container ${className}`} {...props}>
      {isVisible && animatedChildren}
    </div>
  );
};

export default StaggeredContainer;
